import api from './api';

// =====================================================================
// App-Konfiguration (Feature-Flags): GET /api/config/appConfig (öffentlich)
// Response: { id, data: { LOGIN_ENABLED: true, ... } } — Bool-Flags.
// Wird EINMAL pro Session geladen (Modul-Cache + Promise-Dedupe).
// Default-Verhalten: solange die Config lädt oder der Fetch fehlschlägt,
// gelten Flags als true (Feature sichtbar) — deshalb defensiv konsumieren.
// =====================================================================

/** Flag: Turniersoftware (Turnier veranstalten, Live-Turniere-Widgets). */
export const TOURNAMENT_SOFTWARE_ENABLED = 'TOURNAMENT_SOFTWARE_ENABLED';

let cachedConfig: Record<string, boolean> | null = null;
let pendingRequest: Promise<Record<string, boolean>> | null = null;

/**
 * Lädt die App-Config genau einmal. Parallele Aufrufe teilen sich denselben
 * Request; ein Fehlschlag wird NICHT gecacht (nächster Aufruf versucht es neu)
 * und liefert ein leeres Objekt → alle Flags fallen auf ihren Default zurück.
 */
export const getAppConfig = (): Promise<Record<string, boolean>> => {
  if (cachedConfig) return Promise.resolve(cachedConfig);
  if (pendingRequest) return pendingRequest;

  pendingRequest = api
    .get('/api/config/appConfig')
    .then((response) => {
      const data = response.data?.data;
      cachedConfig = data && typeof data === 'object' ? (data as Record<string, boolean>) : {};
      return cachedConfig;
    })
    .catch(() => {
      // Fehler nicht cachen — beim nächsten Aufruf erneut versuchen
      pendingRequest = null;
      return {} as Record<string, boolean>;
    });

  return pendingRequest;
};

/**
 * Prüft ein Bool-Flag. Fehlt der Wert (Config lädt nicht / Key unbekannt),
 * gilt `defaultValue` (Standard: true → Feature sichtbar).
 */
export const isEnabled = async (key: string, defaultValue = true): Promise<boolean> => {
  const config = await getAppConfig();
  const value = config[key];
  return typeof value === 'boolean' ? value : defaultValue;
};

const configService = { getAppConfig, isEnabled };
export default configService;
